// src/SignUpChoice.jsx
import { useNavigate } from "react-router-dom";

const TRELLI_GREEN = "#00B074";

export default function SignUpChoice() {
  const nav = useNavigate();

  // shared card styles
  const box = {
    border: "1px solid #E5E7EB",
    borderRadius: 14,
    padding: 16,
    width: "100%",
    background: "#fff",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: 10,
  };

  const coming = {
    ...box,
    opacity: 0.4,
    pointerEvents: "none",
  };

  // page-level CSS to handle the responsive grid + prevent horizontal scroll on phones
  const styles = `
    .signup-page {
      min-height: 100dvh;
      display: grid;
      place-items: center;
      padding: 24px;
      background:
        radial-gradient(1200px 600px at 10% -20%, rgba(0,176,116,0.08), transparent 50%),
        radial-gradient(800px 400px at 110% 120%, rgba(244,197,66,0.06), transparent 40%),
        #f8faf9;
      overflow-x: hidden;     /* remove tiny right-scroll on small screens */
      width: 100%;
      box-sizing: border-box;
    }
    .signup-wrap {
      width: 100%;
      max-width: 1200px;      /* gives room for horizontal layout on laptop */
      box-sizing: border-box;
      display: grid;
      gap: 16px;
    }
    .signup-head {
      display: grid;
      gap: 6px;
    }
    .brand {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .brand-badge {
      width: 40px;
      height: 40px;
      border-radius: 999px;
      display: grid;
      place-items: center;
      font-weight: 900;
      font-size: 20px;
      color: #fff;
      background: ${TRELLI_GREEN};
      flex: 0 0 auto;
    }
    .brand-copy small {
      font-size: 12px;
      color: #667085;
    }
    /* Cards grid: single column on phones, horizontal on laptops/desktops */
    .cards {
      display: grid;
      gap: 16px;
      grid-template-columns: 1fr;
      align-items: stretch;
    }
    @media (min-width: 1024px) { /* laptop and up */
      .cards {
        grid-template-columns: repeat(4, minmax(220px, 1fr));
      }
    }
    .actions {
      margin-top: 8px;
      text-align: left;
    }
    .back-link {
      border: none;
      background: transparent;
      color: ${TRELLI_GREEN};
      font-weight: 700;
      text-decoration: underline;
      cursor: pointer;
      padding: 0;
    }
    /* Ensure no element can cause overflow */
    .cards > * { max-width: 100%; }
  `;

  return (
    <div className="signup-page">
      <style>{styles}</style>

      <div className="signup-wrap">
        {/* Brand */}
        <div className="brand">
          <div className="brand-badge">T</div>
          <div className="brand-copy">
            <div style={{ fontWeight: 900, fontSize: 20 }}>Trelli</div>
            <small>Start where you are. Trelli grows with you.</small>
          </div>
        </div>

        {/* Heading */}
        <div className="signup-head">
          <h2 style={{ margin: "4px 0 0" }}>Create your account</h2>
          <p style={{ marginTop: 4, color: "#475467" }}>
            Choose a plan to get started. Only the Beta is available today; others are coming soon.
          </p>
        </div>

        {/* Cards — responsive grid */}
        <div className="cards">
          {/* Beta (active) */}
          <div style={box}>
            <div style={{ fontWeight: 800, fontSize: 16 }}>Beta (Free)</div>
            <p style={{ margin: "6px 0 12px", color: "#475467" }}>
              Join the live beta. Connect your existing accounts, get proactive budget tools as we build.
            </p>
            <button
              onClick={() => nav("/signup/beta")}
              style={{
                width: "100%",
                height: 44,
                borderRadius: 12,
                border: "none",
                background: TRELLI_GREEN,
                color: "#fff",
                fontWeight: 800,
                cursor: "pointer"
              }}
            >
              Continue with Beta
            </button>
          </div>

          {/* Free (manual) — coming */}
          <div style={coming}>
            <div style={{ fontWeight: 800, fontSize: 16 }}>Free (Manual)</div>
            <p style={{ margin: "6px 0 0", color: "#475467" }}>
              Track budgets manually. No Plaid connections. Coming soon.
            </p>
          </div>

          {/* Standard — coming */}
          <div style={coming}>
            <div style={{ fontWeight: 800, fontSize: 16 }}>Standard — $9.99/mo</div>
            <p style={{ margin: "6px 0 0", color: "#475467" }}>
              Full features with monthly billing or discounted yearly pricing. Coming soon.
            </p>
          </div>

          {/* Family — coming */}
          <div style={coming}>
            <div style={{ fontWeight: 800, fontSize: 16 }}>Family — $14.99/mo</div>
            <p style={{ margin: "6px 0 0", color: "#475467" }}>
              Add a co-head of household + limited access for kids/family. Yearly discount available.
              Coming soon.
            </p>
          </div>
        </div>

        {/* Back link */}
        <div className="actions">
          <button onClick={() => nav("/")} className="back-link">
            Back to sign in
          </button>
        </div>
      </div>
    </div>
  );
}